import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  sizes: [],
  error: "",
};

export const getSizes = createAsyncThunk(
  "size/getSizes",
  async (_, thunkApi) => {
    const { rejectedWithValue } = thunkApi;
    try {
      const res = await axios.get("product/api/v1/sizes/?page_size=10000");
      // console.log(res.data.results);
      const data = res.data.results.map((size) => ({
        id: size.id,
        name: size.name,
      }));

      return data;
    } catch (err) {
      return rejectedWithValue(err);
    }
  },
);

const sizeSlice = createSlice({
  name: "size",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSizes.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getSizes.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.sizes = action.payload;
    });
    builder.addCase(getSizes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default sizeSlice.reducer;
